__turbopack_context__.v({
  "removeFileButton": "styles-module-scss-module__HMGE2G__removeFileButton",
  "uploadedFileDesc": "styles-module-scss-module__HMGE2G__uploadedFileDesc",
  "uploadedFileItem": "styles-module-scss-module__HMGE2G__uploadedFileItem",
  "uploadedFileType": "styles-module-scss-module__HMGE2G__uploadedFileType",
  "uploadedFilesWrapper": "styles-module-scss-module__HMGE2G__uploadedFilesWrapper",
});
